import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImagemodalService {

  private _imageLink$ = new BehaviorSubject<string>("");

  constructor() { }

  get imageLink$() {
    return this._imageLink$.asObservable();
  }

  updateImageSource(newImage: string)
  {
    this._imageLink$.next(newImage);
  }

}
